import React from 'react';

import type { TErrorFallback } from '../error-boundary';
import ErrorFlat from '../error-flat';

const DefaultFallback: TErrorFallback = (location, error, errorInfo, loggedErrors) => {
  return (
    <ErrorFlat error={error} show={process.env.NODE_ENV == 'development'}>
      <h4>Error in {location}</h4>
      <div>An error has occured. Please try again later.</div>
      <div>If the issue persists please contact support.</div>
    </ErrorFlat>
  );
};

export default DefaultFallback;
